import { Xhr } from 'hudl-base';
import PersonalizationUtility from './personalization-utility';

// [paul.graff@hudl.com] 2016-1-29
// Prevent GET requests from being cached on older versions of IE
const ajaxGetOptions = {
  cache: false,
  traditional: true,
};

const Services = {
  getMiniProfile(feedUserType, feedUserRelatedId, data) {
    const requestUrl = `/home/mini-profile/${feedUserType}-${feedUserRelatedId}`;
    return Xhr.instance.get(requestUrl, data, ajaxGetOptions);
  },
  getRenderedHomeTimeline(data) {
    return Xhr.instance.get('/api/v2/feedconsumer/rendered-home-timeline', data, ajaxGetOptions);
  },
  getHomeTimeline(data) {
    return Xhr.instance.get('/api/v2/feedconsumer/home-timeline', data, ajaxGetOptions);
  },
  getUserTimeline(feedUserType, feedUserRelatedId, data) {
    const requestUrl = `/api/v2/feedconsumer/rendered-user-timeline/${feedUserType}-${feedUserRelatedId}`;
    return Xhr.instance.get(requestUrl, data, ajaxGetOptions);
  },
  submitFeedback(data) {
    return Xhr.instance.post('/home/submit-feedback', data);
  },
  viewFollowOnboarding(data) {
    return Xhr.instance.post('/home/view-follow-onboarding', data);
  },
  getInitialAttachmentsForTeam(teamId, data) {
    return Xhr.instance.get('/attachment/getInitialAttachmentsForTeam/' + teamId, data);
  },
  getMoreAttachmentsForTeam(teamId, page, data) {
    const requestUrl = `/attachment/getMoreAttachmentsForTeam/${teamId}/page/${page}`;
    return Xhr.instance.get(requestUrl, data);
  },
  deleteAttachmentForTeam(teamId, attachmentId, data) {
    const requestUrl = `/attachment/${attachmentId}/teamId/${teamId}`;
    return Xhr.instance.delete(requestUrl, data);
  },
  getPublicSuggestions(data) {
    return Xhr.instance.get('/api/v2/feedconsumer/friendship/public-recommendations', data);
  },
  getSuggestedAthletes(data) {
    return Xhr.instance.post('/api/v2/feedconsumer/friendship/recommendations', data);
  },
  getFriendships(feedUserType, feedUserRelatedId, data) {
    const requestUrl = `/feedconsumer/friendship/get-friendships/${feedUserType}-${feedUserRelatedId}`;
    return Xhr.instance.get(requestUrl, data, ajaxGetOptions);
  },
  isFollowing(feedUserType, feedUserRelatedId, data) {
    const requestUrl = `/api/v2/feedconsumer/friendship/is-following/${feedUserType}-${feedUserRelatedId}`;
    return Xhr.instance.get(requestUrl, data, ajaxGetOptions);
  },
  followUser(data) {
    return Xhr.instance.post('/api/v2/feedproducer/friendship/follow-user', data);
  },
  unfollowUser(data) {
    return Xhr.instance.post('/api/v2/feedproducer/friendship/unfollow-user', data);
  },
  followTeam(data) {
    return Xhr.instance.post('/api/v2/feedproducer/friendship/follow-team', data);
  },
  unfollowTeam(data) {
    return Xhr.instance.post('/api/v2/feedproducer/friendship/unfollow-team', data);
  },
  addReaction(communityContentType, communityContentRelatedId, reaction, data) {
    const requestUrl = '/api/v2/feedproducer/reactions/' +
      `${communityContentType}-${communityContentRelatedId}/${reaction}`;
    return Xhr.instance.post(requestUrl, data);
  },
  removeReaction(communityContentType, communityContentRelatedId, reaction, data) {
    const requestUrl = '/api/v2/feedproducer/reactions/' +
      `${communityContentType}-${communityContentRelatedId}/${reaction}`;
    return Xhr.instance.delete(requestUrl, data);
  },
  getInteractions(communityContentType, communityContentRelatedId, data) {
    const requestUrl = `/api/v2/feedconsumer/interactions/${communityContentType}-${communityContentRelatedId}`;
    return Xhr.instance.get(requestUrl, data, ajaxGetOptions);
  },
  getTaggedUsers(communityContentType, communityContentRelatedId, data) {
    const prefix = '/api/v2/feedconsumer/community-content-metadata';
    const requestUrl = `${prefix}/${communityContentType}-${communityContentRelatedId}/tagged-users`;
    return Xhr.instance.get(requestUrl, data, ajaxGetOptions);
  },
  searchAthlete(data) {
    const recentTeamIds = PersonalizationUtility.getRecentTeamIds();
    data.personalizationData = {
      recentTeamIds: recentTeamIds,
    };
    return Xhr.instance.post('/api/v3/community-search/feed-users/search', data);
  },
  logCommunitySearchFeedUsersInteraction(interaction, feedUserId, experiment, requestId, position, isFollowing) {
    return Xhr.instance.post('/api/v3/community-search/log/feed-users-interaction', {
      interaction,
      feedUserId,
      experiment,
      requestId,
      position,
      isFollowing,
    });
  },
  dismissFeedItem(contentId, data) {
    return Xhr.instance.post('/api/v2/feedproducer/home-timeline/items/' + contentId + '/dismiss', data);
  },
  dismissProfileFeedItem(contentId, feedUserId, feedUserType, data) {
    const requestUrl = `/api/v2/feedproducer/user-timeline/items/${contentId}/${feedUserType}-${feedUserId}/dismiss`;
    return Xhr.instance.post(requestUrl, data);
  },
  getFeedUser(feedUserType, feedUserRelatedId, data) {
    const requestUrl = `/api/v2/feedconsumer/feed-user/${feedUserType}-${feedUserRelatedId}`;
    return Xhr.instance.get(requestUrl, data, ajaxGetOptions);
  },
  getCurrentUserDetails(data) {
    return Xhr.instance.get('/api/v2/feedconsumer/feed-user-details', data, ajaxGetOptions);
  },
  loadDiscoveryTimelines() {
    const requestData = {
      teamIds: PersonalizationUtility.getRecentTeamIds(),
    };

    return Xhr.instance.get('/api/v2/feedconsumer/discovery/timelines', requestData, ajaxGetOptions);
  },
  getExploreTimeline(timelineType, data) {
    const requestData = Object.assign({}, data);

    const requestUrl = `/api/v2/feedconsumer/discovery/timelines/${timelineType}`;
    return Xhr.instance.get(requestUrl, requestData, ajaxGetOptions);
  },
  logFeedContentView(data) {
    return Xhr.instance.post('/api/v2/feedconsumer/log/feed-content/view', data);
  },
  logFeedContentClick(data) {
    return Xhr.instance.post('/api/v2/feedconsumer/log/feed-content/click', data);
  },
  logFeedContentPlayVideo(data) {
    return Xhr.instance.post('/api/v2/feedconsumer/log/feed-content/play-video', data);
  },
  logFeedEndPlaylist(data) {
    return Xhr.instance.post('/api/v2/feedconsumer/log/feed-end/playlist', data);
  },
  logFeedEndExchange(data) {
    return Xhr.instance.post('/api/v2/feedconsumer/log/feed-end/exchange', data);
  },
  logFeedEndFollow(data) {
    return Xhr.instance.post('/api/v2/feedconsumer/log/feed-end/follow', data);
  },
  logFeedEndExplore(data) {
    return Xhr.instance.post('/api/v2/feedconsumer/log/feed-end/explore', data);
  },
  logProfileClick(data) {
    return Xhr.instance.post('/api/v2/feedconsumer/log/profile/click', data);
  },
  logExploreTabView(data) {
    return Xhr.instance.post('/api/v2/feedconsumer/log/explore/tab-view', data);
  },
  dismissBasketballClassicV2OnboardingCard(data) {
    return Xhr.instance.post('/home/dismiss-basketball-classic-v2-onboarding-card', data);
  },
  getRecruiterActivity(data) {
    return Xhr.instance.get('/api/v2/feedconsumer/recruiter-activity/recent', data, ajaxGetOptions);
  },
  updateAthleteProfile(athleteId, data) {
    return Xhr.instance.post(`/athlete/${athleteId}/manage/SaveFieldData`, data);
  },
};

export default Services;
